/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	Text as NativeText,
	TextProps,
} from '@mantine/core';

// Styles
import classes from './Text.module.css';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */

type TTextProps = TextProps & {
	variant?:
		| 'subtitle1'
		| 'subtitle2'
		| 'body1'
		| 'body2'
		| 'body2-medium'
		| 'button'
		| 'caption'
		| 'overline';

	children?: React.ReactNode;
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Text = (props: TTextProps) => {
	/* ******************************** RENDERING ******************************* */
	return <NativeText classNames={classes} {...props} />;
};
